<template>
  <DialogTemplateToolkit
    class-name="create-additional-field"
    :data-qa="'create-additional-field-dialog'"
    :dialog="opened"
    :disabled="loading"
    :first_btn="item ? 'Common.Edit' : 'AdditionalFields.Create'"
    :loading="loading"
    second_btn
    :title="item ? $t('AdditionalFields.EditField') : $t('AdditionalFields.CreateField')"
    width="856"
    @apply="createField"
    @close="$emit( 'close')">
    <template #backBtn>
      <sButton
        v-if="back_step"
        class="bold h7-text px-2"
        data-qa="back-btn"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        small
        type="text"
        @click="$emit( 'back')">
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #card-text>
      <div class="py-2">
        <sForm
          ref="createAdditionalFieldForm"
          label-position="top"
          label-width="100px"
          :model="formData"
          :rules="rules">
          <div class="create-additional-field__wrapper d-flex">
            <sFormItem
              class="create-additional-field__name width-65 mr-4 mb-6"
              :label="$t('AdditionalFields.FieldName')"
              prop="name">
              <sInput
                clearable
                data-qa="create-additional-field__name"
                :max-length="4000"
                max-rows="5"
                :placeholder="$t('Common.EnterName')"
                rows="1"
                type="textarea"
                :value.sync="formData.name"/>
            </sFormItem>
            <sFormItem
              class="width-30 mb-6"
              :label="$t('AdditionalFields.FieldType')"
              prop="type">
              <sSelect
                data-qa="create-additional-field__type"
                :disabled="true"
                :placeholder="$t('AdditionalFields.FieldType')"
                popper-class="create-additional-field__select-type"
                :value.sync="formData.type"
                value-key="typeId"
                @update:value="changeType">
                <sOption
                  v-for="item_type in additional_types"
                  :key="`item-${item_type.typeId}`"
                  class="px-8"
                  :data-qa="`item-${item_type.typeId}`"
                  :disabled="loading"
                  :label="item_type.name"
                  :value="item_type">
                  <sIcon
                    class="my-auto mr-4"
                    :type="item_type.icon"/>
                  {{ item_type.name }}
                </sOption>
              </sSelect>
            </sFormItem>
          </div>

          <sFormItem
            v-if="formData.type && formData.type.typeId == 'DECIMAL' && formData.options"
            class="add-additional-field__name mb-5"
            :label="$t('Common.Decimals')"
            prop="decimals">
            <sInput
              class=" width-100"
              clearable
              data-qa="add-additional-field__name"
              :disabled="loading"
              :max-length="4000"
              max-rows="5"
              :placeholder="$t('Common.Decimals')"
              rows="1"
              type="textarea"
              :value.sync="formData.decimals"/>
          </sFormItem>

          <div
            v-if="formData.type && formData.type.typeId == 'DROPDOWN' && formData.options"
            class="create-additional-field__options mb-5">
            <sFormItem
              v-for="(option, index) in formData.options"
              :key="index"
              :label="$t('AdditionalFields.Option') + ' ' + (index + 1)"
              :prop="`options[${index}].value`">
              <sInput
                class="width-60"
                clearable
                data-qa="create-additional-field__option"
                :disabled="loading"
                :max-length="4000"
                max-rows="2"
                :placeholder="$t('Common.EnterName')"
                rows="1"
                type="textarea"
                :value.sync="formData.options[index].value"/>
              <sButton
                v-if="formData.options.length > 2"
                class="create-additional-field__delete-option mr-4 my-auto"
                data-qa="delete-option"
                :disabled="loading"
                icon="delete"
                small
                type="text"
                @click="$_deleteOption(index, formData.options)"/>
            </sFormItem>

            <sButton
              v-if="formData.options.length"
              class="create-additional-field__add-option px-2 h10-links "
              data-qa="btn-add-option"
              :disabled="loading"
              icon="plus"
              icon-size="8px"
              small
              type="text"
              @click="$_addAOption(formData.options, rules)">
              {{ $t('AdditionalFields.AddOption') }}
            </sButton>
          </div>

          <sFormItem
            class="create-additional-field__show_to_perticipant show_to_perticipant"
            prop="show_to_perticipant">
            <template #label>
              <div class="show_to_perticipant__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.ShowParticipantsOnTheSite') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.show_to_perticipant"
              class="show_to_perticipant__group  width-100 "
              data-qa="show_to_perticipant-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="yesOrNoItem in $_options_yes_or_no"
                :key="yesOrNoItem.value"
                :data-qa="'show_to_perticipant-' + yesOrNoItem.value"
                :label="yesOrNoItem.value">
                {{ yesOrNoItem.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>

          <sFormItem
            v-if="showAsSpecialFieldAvailable"
            class="create-additional-field__show_as_special_field mb-5"
            prop="showAsSpecialField">
            <template #label>
              <div class="pa-0 ma-0 mb-4 h5-headline">
                {{ $t('AdditionalFields.ShowAsSpecialField') }}
              </div>
            </template>
            <sRadioGroup
              v-model="formData.showAsSpecialField"
              class="width-100 "
              data-qa="show_as_special_field-group"
              :disabled="loading"
              row>
              <sRadio
                v-for="yesOrNoItem in $_options_yes_or_no"
                :key="yesOrNoItem.value"
                :data-qa="'show_as_special_field-' + yesOrNoItem.value"
                :label="yesOrNoItem.value">
                {{ yesOrNoItem.label }}
              </sRadio>
            </sRadioGroup>
          </sFormItem>
        </sForm>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { additionalFieldsMixin } from 'mixins'

export default {
  name: 'createAdditionalField',
  mixins: [additionalFieldsMixin],
  data() {
    const that = this
    return {
      formData: {
        name: '',
        type: {},
        options: [],
        show_to_perticipant: true,
        showAsSpecialField: false,
        decimals: '0'
      },

      rules: {
        name: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            required: true,
            min: 2,
            message: this.$t('Validate.minLength', {number: 2, type: this.$tc('Common.characters', 2) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 4000,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          }
        ],
        type: {
          trigger: 'change',
          required: true,
        },
        decimals: {
          trigger: 'change',
          required: true,
          min: 1,
          message: that.$t('Validate.Required')
        },
      }
    }
  },
  props: {
    back_step: {
      type: Boolean
    },
    bindingLevel: {
      type: String
    },
    create_type: {
      type: Object
    },
    item: {
      type: Object
    },
    opened: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  created( ) {
    if (this.opened) {
      this.open()
    }
  },
  methods: {
    open() {
      if (this.item?.id) {
        let decimals = 0
        if (this.item.typeId === 'DECIMAL') {
          decimals = this.item.settingValues.
            find(set => set.settingType == 'DECIMALS' && set.value?.length)?.
            value || '0'
        }

        let type = this.$_.cloneDeep(this.item.type)
        if (!type) {
          type = {
            typeId: this.item.typeId
          }
        }
        this.formData = {
          name: this.item.caption,
          type: type,
          options: this.item.settingValues.
            filter(opt => opt.settingType == 'SELECT_OPTION').
            map(opt => ({value: opt.value, id: opt.id})),
          show_to_perticipant: this.item.showForBidders,
          showAsSpecialField: this.item.showAsSpecialField,
          decimals: decimals.toString()
        }
      } else {
        this.formData.type = this.$_.cloneDeep(this.create_type)
        if (this.formData.type.typeId == 'DROPDOWN' ) {
          this.changeType(this.formData.type)
        }
      }
    },
    close() {
      this.formData.options = []
    },
    changeType(type ) {
      this.$_changeFieldType(type, this.formData.options, this.rules)
    },
    async createField() {

      await this.$refs.createAdditionalFieldForm.validate()

      if (this.formData.type.typeId != 'DROPDOWN' && this.formData.options?.length) {
        this.formData.options = []
      }
      /*if (this.formData.decimals) {
        this.formData.settingValues.push(
          {
            value: this.formData.decimals + '',
            settingType: 'DECIMALS'
          })
      }*/

      if ( this.item?.id  ) {
        this.$emit('editField', {...this.item, formData: this.formData })
      } else {
        this.$emit('createField', this.formData)
      }
    },
  },
  computed: {
    showAsSpecialFieldAvailable() {
      return this.formData.type?.typeId === 'DECIMAL' && this.bindingLevel == 'LOT'
    }
  },
  watch: {
    opened(val) {
      if ( !val ) {
        this.close()
      }
    },
    showAsSpecialFieldAvailable(value) {
      if (!value) {
        this.formData.showAsSpecialField = false
      }
    }
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
